import EventEmitter from "events";
import { reduce } from "lodash";
import React from "react";

export type Size = { width: number, height: number };

export class IFrameContextClass extends EventEmitter {
    public minSizeProviderStack: (() => Size)[] = [];
    
    onContentChanged(cb: () => void) { this.on("onContentChanged", cb); }
    offContentChanged(cb: () => void) { this.removeListener("onContentChanged", cb); }
    notifyContentChanged() { this.emit("onContentChanged"); }



    // *******************************************
    // Min Size Change Notification System
    // We use that to notify the parent that the size of the content should be bigger
    // because something absolute and independent is displayed over the top of it and 
    // it cannot be seen/calculated by the parent.
    // *******************************************
    onMinSizeChanged(cb: (width: number, height: number) => void) { this.on("minSizeChanged", cb); }
    offMinSizeChanged(cb: (width: number, height: number) => void) { this.removeListener("minSizeChanged", cb); }
    notifyMinSizeChange() { 
        const minSize = this.getMinSize();
        this.emit("minSizeChanged", minSize.width, minSize.height); 
    }

    // Min size provider is a tool to allow a component to provide a minimum size to the iframe
    // for when these component are displayer as absolute positioning over the top and that their
    // size is not taken into account by surrouding div. In short : for the big modals.
    public addMinSizeProvider(provider: () => Size) {
        this.minSizeProviderStack.push(provider);
    }
    public removeMinSizeProvider(provider: () => Size) {
        this.minSizeProviderStack = this.minSizeProviderStack.filter(p => p !== provider);
    }
    public getMinSize() {
        const maxOfMins = reduce(this.minSizeProviderStack, (acc, provider) => {
            const { width, height } = provider();
            acc.width = Math.max(acc.width, width);
            acc.height = Math.max(acc.height, height);
            return acc;
        }, { width: 0, height: 0 });

        return maxOfMins;
    }
}

export const IFrameContext = React.createContext<IFrameContextClass>(new IFrameContextClass());
